
<template>
  <div class="footer">
    <!-- TODO: refactor markup -->

    <div class="container">
      <div class="row">
        <b-col md="4">
          <h4 v-translate>Contact</h4>
          <ul class="list-footer">
            <li>
              <a href="" @click.prevent="$emit('showModal', 'address')"><b-icon icon="house-door" class="mr-2"/><translate>Address office</translate></a>
            </li>
            <li>
              <a href="" @click.prevent="$emit('showModal', 'email')"><b-icon icon="envelope" class="mr-2"/><translate>Email address</translate></a>
            </li>
            <li>
              <a href="tel:0034922724642"><b-icon icon="phone"  class="mr-2"/><translate>call</translate>: 0034 / 922.724.642</a>
            </li>
          </ul>
        </b-col>
        <b-col md="4">
          <h4>About us</h4>
          <ul class="list-footer">
            <li>
              <a href="#" @click.prevent="$emit('showModal', 'contact')"><b-icon icon="geo-alt"  class="mr-2"/><translate>Contact</translate></a>
            </li>
            <li>
              <a href="#" @click.prevent="$emit('showModal', 'terms')"><b-icon icon="receipt"  class="mr-2"/><translate>Terms and conditions of payment</translate></a>
            </li>
            <li>
              <a href="#" @click.prevent="$emit('showModal', 'cancel')"><b-icon icon="x-circle-fill"  class="mr-2"/><translate>Cancellation policy</translate></a>
            </li>
          </ul>
        </b-col>
        <b-col md="4">
          <h4 v-translate>Documents</h4>
          <ul class="list-footer">
            <li>
              <a href="#" @click.prevent="$emit('showModal')"><b-icon icon="receipt-cutoff"  class="mr-2"/><translate>B2B Instructions</translate></a>
            </li>
            <li>
              <a href="#"><b-icon icon="file-text"  class="mr-2"/><translate>Newsletter</translate></a>
            </li>
            <li>
              <a  href="http://b2btest.marioviajes.com/assets/images/CIF-definitivo.pdf" target="_blank"><b-icon icon="folder"  class="mr-2"/><translate>Other documents</translate></a>
            </li>
          </ul>
        </b-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
